import Text from 'antd/lib/typography/Text';
import React, { useContext, useState } from 'react';

import { toCurrency } from 'utils/utils';
import DataGrid from 'components/DataGrid';
import { DataGridColDef, DataGridProps } from 'components/DataGrid/DataGrid';
import { FormInstance } from 'antd/lib/form';
import { sumBy } from 'lodash';

import { useModalState } from 'hooks/useModalState';
import AssetTargetPhaseModal from './AssetTargetPhaseModal';
import { AuthContext } from 'components/Auth/Auth';

export type AssetsTableProps<D = any> = Omit<DataGridProps<D>, 'columns'> & {
  form?: FormInstance;
  currcode?: string;
  assets?: any;
  offerid?: number;
  prcode?: string;
  tpidclient?: number;
  ctrid?: number;
  effectDate: string;
  handleTarget: (target: any) => void;
  disabled?: boolean;
  hideModalAsset?: boolean;
  vatrefundduration:number;
};

const AssetsTable = (props: AssetsTableProps) => {
  const { isInspect } = useContext(AuthContext);
  const [state] = useState({
    isLoading: false,
    isModSelected: false,
    newDuration: 0,
    targetdate: '',
    feesamount: 0,
    feesformula: '',
    totalNet: 0,
    totalTax: 0,
    totalGross: 0,
    selectedAsset: '',
  });
  const totalRV = sumBy(props.assets, 'assetrvamount');
  const taxRV = (totalRV * 20) / 100;
  const handleTarget = (data: any) => {
    props.handleTarget(data);
  };
  // eslint-disable-next-line no-unused-vars
  /*  const calculateFees = (asset: any, pricing?: PricingResponse) => {
    finEngine
      .calculateServiceWithStep({
        servReq: {
          finSchedule: [],
          inDownPayment: 0,
          inFinAmount: asset.assetnetamount ?? 0,
          inFollowGP: true,
          inGPDuration: 0,
          inPstype: pricing?.ctecategory ?? '',
          inRoudingAmount: 2,
          inServcalculationmethod:
            pricing?.serviceResponse.servcalculationmethod ?? '',
          inServfixedamount: pricing?.serviceResponse.servfixedamount ?? 0,
          inServiceduration: pricing?.serviceResponse.servduration ?? '',
          inServpercentage: pricing?.serviceResponse.servpercentage ?? 0,
          inTaxcode: pricing?.taxcode ?? '',
          inTaxrate: pricing?.taxrate ?? 0,
          inDuration: 0,
          inInvestAmount: asset.assetnetamount,
          inAssetAmount: asset.assetnetamount,
          inServperiodicity: pricing?.serviceResponse.servperiodicity ?? '1',
          inServDurationFree: pricing?.serviceResponse.servdurationdefault ?? 1,
          inStartDate: dateToString(props.form?.getFieldValue('targetdate')),
          inServbasis: pricing?.serviceResponse.servbasis ?? 'FLAT',

          inCalculatedamountbasis:
            pricing?.serviceResponse.calculatedamountbasis ?? 'FINANCING',

          inMarginoncalcultedamount:
            pricing?.serviceResponse.marginoncalulatedamount ?? 0,
          inAdditionalcostaftermargin:
            pricing?.serviceResponse.additionalcostaftermargin ?? 0,

          servStep: pricing?.serviceStepList ?? [],
        },
      })
      .then((res) => {
        if (res.success) {
          message.success('Service - ' + res.message);

          props.form?.setFieldsValue({
            feesamount: res.installmentamount,
            feestax: (res.installmentamount * (pricing?.taxrate ?? 0)) / 100,
            feestaxcode: pricing?.taxcode,
            feestaxrate: pricing?.taxrate,
            feestype: pricing?.ctetype,
            feescategory: pricing?.ctecategory,
          });

          calculateTotal();
        }
      });
  };

  const calculateTotal = () => {
    if (props.form?.getFieldValue('targetphase') === 'STOCKIN') {
      props.form?.setFieldsValue({
        invoicenetamount: props.form.getFieldValue('feesamount'),
        invoicetaxamount: props.form.getFieldValue('feestax'),
        invoicegrossamount:
          props.form.getFieldValue('feesamount') +
          props.form.getFieldValue('feestax'),
      });
    } else {
      props.form?.setFieldsValue({
        invoicenetamount: totalRV,
        invoicetaxamount: taxRV,
        invoicegrossamount: totalRV + taxRV,
      });
    }
  };

  */

  const { visible, close, open } = useModalState(false);

  const columns: DataGridColDef<any>[] = [
    {
      comcode: 'Asset.assetreference',
      dataIndex: 'assetreference',
      fixed:'left',
      width: 100,
      render: (value, record) => (
        <a
          onClick={() => {
            if (!props.hideModalAsset) {
              state.selectedAsset = record;
              open();
            }else if (isInspect) {
              state.selectedAsset = record;
              open();
            }
          }}
        >
          {record.assetreference}
        </a>
      ),
    },
    {
      comcode: 'Asset.assetdescription',
      dataIndex: 'assetlabel',
      fixed:'left',
      width: 200,
    },

    {
      align: 'right',
      comcode: 'Asset.assetnetamount',
      dataIndex: 'assetnetamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
    },
    {
      align: 'right',
      comcode: 'Asset.assettaxamount',
      dataIndex: 'assettaxamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
    },
    {
      comcode: 'Asset.assetrvamount',
      dataIndex: 'assetrvamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },
    {
      comcode: 'Asset.finrvamount',
      dataIndex: 'finrvamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },
    {
      comcode: 'Asset.rentalpart',
      dataIndex: 'rentalpart',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },
    {
      comcode: 'Asset.irvamount',
      dataIndex: 'irvamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },
    {
      comcode: 'Asset.rvgap',
      dataIndex: 'rvgap',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },
    {
      comcode: 'Asset.targetphase',
      dataIndex: 'targetphase',
      width: 100,
      render: (value, record) =>
        record?.targetphase === 'STOCK' || record?.targetphase === 'STOCKIN' ? (
          <Text style={{ color: 'red' }}>to Stock</Text>
        ) : record?.targetphase === 'SALE' ||
          record?.targetphase === 'ASSETOUT' ? (
          <Text style={{ color: 'green' }}>To sale</Text>
        ) : null,
    },
    {
      comcode: 'Asset.degfeesamount',
      dataIndex: 'degfeesamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },
    {
      comcode: 'Asset.tpofamount',
      dataIndex: 'tpofamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },

    {
      comcode: 'Asset.spamount',
      dataIndex: 'spamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
    },

    {
      comcode: 'Asset.saleamount',
      dataIndex: 'saleamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
      fixed:'right',
    },
    {
      comcode: 'Asset.vatrefund',
      dataIndex: 'vatrefund',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
      fixed:'right',
    },
    {
      comcode: 'Asset.totalInvoiceamount',
      dataIndex: 'totalinvoiceamount',
      render: (value) => toCurrency(value, props?.currcode ?? localStorage.getItem('currcode') ?? ''),
      width: 150,
      align: 'right',
      fixed:'right',
    },
    {
      comcode: 'maxMileageToUse',
      dataIndex: 'maxMileageToUse',
      width: 150,
      align: 'right',
      fixed:'right',
    },
  ];
  return (
    <>
      <DataGrid columns={columns} dataSource={props.assets} {...props} />
      <AssetTargetPhaseModal
        currcode={props.currcode}
        asset={state.selectedAsset}
        offerid={props.offerid}
        prcode={props.prcode}
        tpidclient={props.tpidclient}
        onCancel={close}
        onSave={handleTarget}
        visible={visible}
        effectDate={props.effectDate}
        form={props.form}
        disabled={props?.disabled ?? false}
        vatrefundduration={props?.vatrefundduration}
      />
    </>
  );
};

export default AssetsTable;
